
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/tidy-first",
      function () {
        return require("private-next-pages/books/tidy-first.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/tidy-first"])
      });
    }
  